import { type CSSProperties, type ReactNode } from 'react';
import { HeadingShared, type HeadingClassNames } from './HeadingShared';

interface Props {
  children: string;
  classNames?: HeadingClassNames;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  spacing?: 'both' | 'top' | 'bottom' | 'none';
  sub?: ReactNode;
  style?: CSSProperties;
  start?: ReactNode;
  end?: ReactNode;
}

export function Heading(props: Props) {
  return (
    <HeadingShared
      classNames={props.classNames}
      end={props.end}
      level={props.level}
      spacing={props.spacing}
      start={props.start}
      sub={props.sub}
    >
      {props.children}
    </HeadingShared>
  );
}
